import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { retry } from 'rxjs/operators';

const API_URL = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) { }

  getUsuarios(): Observable<any[]> {
    return this.http.get<any[]>(API_URL+'/usuarios/obtener').pipe(
      retry(1)
    );
  }

  getRoles(): Observable<any[]> {
    return this.http.get<any[]>(API_URL+'/roles/obtener').pipe(
      retry(1)
    );
  }

  getTiposDoc(): Observable<any[]> {
    return this.http.get<any[]>(API_URL+'/tipo/doc/obtener').pipe(
      retry(1)
    );
  }

  deleteUsuario(idUsuario:number):Observable<any>{
    return this.http.put<any>(API_URL+ `/usuarios/desactivar/${idUsuario}`,null).pipe(
      retry(1)
    );
  }

  activarUsuario(idUsuario:number):Observable<any>{
    return this.http.put<any>(API_URL+ `/usuarios/activar/${idUsuario}`,null).pipe(
      retry(1)
    );
  }

  altaUsuario(body:any):Observable<any>{
    return this.http.post(API_URL + '/usuarios/crear', body);
  }


  editarUsuario(body:any):Observable<any>{
    return this.http.put<any>(API_URL+ `/usuarios/editar`,body).pipe(
      retry(1)
    );
  }
}